import { render, staticRenderFns } from "./_expiration_form.vue?vue&type=template&id=2f0c1cbc&scoped=true&"
import script from "./_expiration_form.vue?vue&type=script&lang=js&"
export * from "./_expiration_form.vue?vue&type=script&lang=js&"
import style0 from "./_expiration_form.vue?vue&type=style&index=0&id=2f0c1cbc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c1cbc",
  null
  
)

export default component.exports